// libraries
import React, { useState } from "react";
import { DatePicker, TimePicker } from "antd";

// styles
import styles from "./styles.module.scss";
import "antd/dist/antd.css";

const { RangePicker } = DatePicker;

const DateTimePicker = ({ formData, setFormData, isDate, toggleModal }) => {
  const [value, setValue] = useState(null);

  const onChange = (value, dateString) => {
    setValue(dateString);
  };

  const handleClick = () => {
    if (isDate) {
      setFormData({
        ...formData,
        eventStartDate: value[0],
        eventEndDate: value[1],
      });
    } else {
      setFormData({
        ...formData,
        eventStartTime: value[0],
        eventEndTime: value[1],
      });
    }

    toggleModal(true);
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className={styles.picker}>
      {isDate ? (
        <RangePicker
          onChange={onChange}
          bordered
          showNow
          format={["MM-DD-YYYY", "MM-DD-YYYY"]}
        />
      ) : (
        <TimePicker.RangePicker format={"HH:mm"} onChange={onChange} />
      )}
      <div className={styles.btns}>
        <button onClick={() => toggleModal(true)}>Cancel</button>
        <button onClick={handleClick}>Add</button>
      </div>
    </div>
  );
};

export default DateTimePicker;
